import styled from "styled-components"
import useApi from "../../../hooks/useApi"
import { useModal } from "../../../contexts/ModalContext"
import { useEffect, useMemo, useState } from "react"
import { useParams } from "react-router-dom"

import { formatarData } from "../../../Funcoes/FormatarData"
import { formatBRLFromCents } from "../../../Funcoes/Money"

import { PiNotePencilThin } from "react-icons/pi";
import { IoAdd, IoAttachOutline } from "react-icons/io5";
import { GoSearch, GoEye } from "react-icons/go"
import ModalNovaNF from "./ModalNovaNF"
import ModalEmailsNF from "./ModalEmailsNF"
import ModalDetalhesBM from "./ModalDetalhesBM"
import ModalAnexosBM from "./ModalAnexosBM"
import ModalVisualizarNF from "./ModalVisualizarNF"
import ModalEditarNFs from "./ModalEditarNFs"

const Container = styled.div`
    width: 100%;
    flex: 1;
    padding: 15px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    overflow: hidden;
`
const Header = styled.div`
    width: 100%;
    height: 120px;
    display: flex;
    gap: 10px;
    background-color: #fff;
    margin-bottom: 15px;
    border-radius: 15px;
    padding: 15px;
    box-sizing: border-box;
`
const InfoWrapper = styled.div`
    width: 250px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    background-color: #f0f0f0;
    border-radius: 15px;
    p{
        font-size: 20px;
        font-weight: bold;
        margin: 0;
        margin-left: 20px;
    }
    h3 {
        font-size: 12px;
        color: #555;
        margin: 0;
        margin-left: 20px;
    }
`
const TabelaWrapper = styled.div`
    width: 100%;
    flex: 1;
    background-color: #fff;
    border-radius: 15px;
    overflow: auto;
`
const Tabela = styled.table`
    width: 100%;
    border-collapse: collapse;
    color: #333;
    thead {
        background-color: #f0f0f0;
        position: sticky;
        top: 0;
        z-index: 2;
    }
    tbody {
        tr {
            border-bottom: 1px solid #ccc;
            height: 45px;
            font-size: 14px;
            padding: 0 15px;
            &:nth-child(even) {
                background-color: #fafafa;
            }
            &:hover {
                background-color: #e0f7fa;
            }
            td {
                padding: 0 16px;
            }
        }
    }
`
const LinhaCabecalho = styled.tr`
    height: 45px;
    border-bottom: 2px solid #ccc;
`
const ColunaCabecalho = styled.th`
    width: ${props => props.width || "auto"};
    text-align: left;
    padding: 0 15px;
    color: #242d34;
    font-size: 15px;
`

const StatusNF = styled.p`
    margin: 0;
    color: ${ props => props.status === "PENDENTE" ? "#ff0f07" : props.status === "EMITIDO" ? "#28a745" : "#555" };
    font-weight: bold;
`

const ActionsContainer = styled.div`
    display: flex;
    align-items: center;
    height: 25px;
    min-width: 90px;
    gap: 10px;
`
const IconEdit = styled(PiNotePencilThin)`
    width: 30px;
    height: 100%;
    color: ${props => props.$disabled ? "#adb5bd" : "#007bff"};
    cursor: ${props => props.$disabled ? "not-allowed" : "pointer"};
    pointer-events: ${props => props.$disabled ? "none" : "auto"};
    transition: .2s all ease;
    &:hover {
        transform: ${props => props.$disabled ? "none" : "scale(1.1)"};
        color: ${props => props.$disabled ? "#adb5bd" : "#0056b3"};
    }
`
const IconAdd = styled(IoAdd)`
    width: 30px;
    height: 100%;
    color: ${props => props.$disabled ? "#adb5bd" : "#28a745"};
    cursor: ${props => props.$disabled ? "not-allowed" : "pointer"};
    pointer-events: ${props => props.$disabled ? "none" : "auto"};
    transition: .2s all ease;
    &:hover {
        transform: ${props => props.$disabled ? "none" : "scale(1.1)"};
        color: ${props => props.$disabled ? "#adb5bd" : "#1e7e34"};
    }
`
const Lupa = styled(GoSearch)`
    width: 30px;
    height: 100%;
    color: #6c757d;
    cursor: pointer;
    transition: .2s all ease;
    &:hover {
        transform: scale(1.1);
        color: #5a6268;
    }
`
const IconeAnexo = styled(IoAttachOutline)`
    width: 30px;
    height: 100%;
    color: #6c757d;
    cursor: pointer;
    transition: .2s all ease;
    &:hover {
        transform: scale(1.1);
        color: #5a6268;
    }
`
const Olho = styled(GoEye)`
    width: 30px;
    height: 100%;
    color: #6c757d;
    cursor: pointer;
    transition: .2s all ease;
    &:hover {
        transform: scale(1.1);
        color: #5a6268;
    }
`

const BodyWrapper = () => {

    const api = useApi();
    const { id } = useParams();
    const { isModalOpen, openModal, closeModal } = useModal();

    const [boletins, setBoletins] = useState([]);

    const fetchData = async () => {

        try {

            const { data } = await api.get("/Painel/API/ControleMedicao/GetBoletinsMedicao/index.php?id=" + id);
            console.log(data);

            setBoletins(data.boletins);

        } catch (e) {

            console.error(e);

        }

    }

    useEffect(() => {
        fetchData();
    }, [])

    const totalFaturado = useMemo(() => {

        return boletins.reduce((total, bm) => total + bm.valor, 0);

    }, [ boletins ]);

    const [ selectedBM, setSelectedBM ] = useState(null);
    const [ bmDetalhes, setBmDetalhes ] = useState(null);
    const [ bmAnexos, setBmAnexos ] = useState(null);
    const [ bmVisualizarNF, setBmVisualizarNF ] = useState(null);
    const [ bmEditarNF, setBmEditarNF ] = useState(null);

    const handleAddClick = ({ bm }) => {

        setSelectedBM(bm);
        openModal("novaNF");

    }

    const closeModalNovaNF = () => {

        setSelectedBM(null);
        closeModal();

    }

    const handleDetalhesBM = (bm) => {

        setBmDetalhes(bm);
        openModal("detalhesBM");

    }

    const closeModalDetalhesBM = () => {

        setBmDetalhes(null);
        closeModal();

    }

    const handleAnexosBM = (bm) => {

        setBmAnexos(bm);
        openModal("anexosBM");

    }

    const closeModalAnexosBM = () => {

        setBmAnexos(null);
        closeModal();

    }

    const handleVisualizarNF = (bm) => {

        setBmVisualizarNF(bm);
        openModal("visualizarNF");

    }

    const closeModalVisualizarNF = () => {

        setBmVisualizarNF(null);
        closeModal();

    }

    const handleEditarNF = (bm) => {

        setBmEditarNF(bm);
        openModal("editarNFs");

    }

    const closeModalEditarNFs = () => {

        setBmEditarNF(null);
        closeModal();

    }

    return (
        <>
            <Container>
                <Header>
                    <InfoWrapper>
                        <p>{formatBRLFromCents(totalFaturado)}</p>
                        <h3>VALOR FATURADO</h3>
                    </InfoWrapper>
                </Header>
                <TabelaWrapper>
                    <Tabela>
                        <thead>
                            <LinhaCabecalho>
                                <ColunaCabecalho>Nº BM</ColunaCabecalho>
                                <ColunaCabecalho>DATA MEDIÇÃO</ColunaCabecalho>
                                <ColunaCabecalho>VALOR MEDIÇÃO</ColunaCabecalho>
                                <ColunaCabecalho>BM</ColunaCabecalho>
                                <ColunaCabecalho>STATUS NF</ColunaCabecalho>
                                <ColunaCabecalho>DATA EMISSÃO NF</ColunaCabecalho>
                                <ColunaCabecalho>NF</ColunaCabecalho>
                            </LinhaCabecalho>
                        </thead>
                        <tbody>
                            {boletins.map((bm) => (
                                <tr key={bm.id} >
                                    <td>{bm.num_medicao}</td>
                                    <td>{formatarData(bm.data_medicao)}</td>
                                    <td>{formatBRLFromCents(bm.valor)}</td>
                                    <td>
                                        <ActionsContainer>
                                            <Lupa onClick={() => handleDetalhesBM(bm)} title="Ver detalhes do BM" />
                                            <IconeAnexo onClick={() => handleAnexosBM(bm)} title="Anexos do BM" />
                                        </ActionsContainer>
                                    </td>
                                    <td><StatusNF status={bm.status_nf}>{ bm.status_nf }</StatusNF></td>
                                    <td>{ bm.emissao_nf ? formatarData(bm.emissao_nf) : "-" }</td>
                                    <td>
                                        <ActionsContainer>
                                            <IconAdd
                                                $disabled={bm.status_nf === "EMITIDO"}
                                                onClick={() => bm.status_nf !== "EMITIDO" && handleAddClick({ bm })}
                                                title={bm.status_nf === "EMITIDO" ? "Não é possível adicionar NF após a emissão" : "Adicionar NF"}
                                            />
                                            <IconEdit
                                                $disabled={bm.status_nf === "PENDENTE"}
                                                onClick={() => bm.status_nf !== "PENDENTE" && handleEditarNF(bm)}
                                                title={bm.status_nf === "PENDENTE" ? "Não é possível editar enquanto a NF estiver pendente" : "Editar NFs"}
                                            />
                                            <Olho
                                                onClick={() => handleVisualizarNF(bm)}
                                                title="Ver NF e anexos"
                                            />
                                        </ActionsContainer>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Tabela>
                </TabelaWrapper>
            </Container>
            {
                isModalOpen('novaNF') && (
                    <ModalNovaNF
                        bm={selectedBM}
                        fecharModal={closeModalNovaNF}
                        fetchData={ fetchData }
                    />
                )
            }
            {
                isModalOpen('modalEmailsNF') && (
                    <ModalEmailsNF />
                )
            }
            {
                isModalOpen('detalhesBM') && bmDetalhes && (
                    <ModalDetalhesBM
                        bm={bmDetalhes}
                        fecharModal={closeModalDetalhesBM}
                    />
                )
            }
            {
                isModalOpen('anexosBM') && bmAnexos && (
                    <ModalAnexosBM
                        bm={bmAnexos}
                        fecharModal={closeModalAnexosBM}
                    />
                )
            }
            {
                isModalOpen('visualizarNF') && bmVisualizarNF && (
                    <ModalVisualizarNF
                        bm={bmVisualizarNF}
                        fecharModal={closeModalVisualizarNF}
                    />
                )
            }
            {
                isModalOpen('editarNFs') && bmEditarNF && (
                    <ModalEditarNFs
                        bm={bmEditarNF}
                        fecharModal={closeModalEditarNFs}
                        fetchData={fetchData}
                    />
                )
            }
        </>
    )
}

export default BodyWrapper;